import { ChangeDetectionStrategy, Component } from '@angular/core'

import { CardImageText } from 'app/core/cms/generated/api-types'
import { AnchorCardComponent } from 'app/shared/anchor-card/anchor-card.component'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-card-image-text',
  templateUrl: './card-image-text.component.html',
  styleUrls: ['./card-image-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AnchorCardComponent],
  providers: [{ provide: CmsBlock, useExisting: CardImageTextComponent }],
})
export class CardImageTextComponent extends CmsBlock<CardImageText> {
  readonly __typename = 'CardImageText'
}
